<template>
    <defaultSec :title="'< 返回'" :returnState="true" class="ai-conversation-detail">

                <div style="margin-bottom: 20px">
                    <el-upload
                        class="upload-demo"
                        :action="''"
                        :show-file-list="false"
                        :httpRequest="(file)=>uploadFile(file,{})">
                        <el-button icon="el-icon-paperclip" size="small" type="danger">上传文件</el-button>
                    </el-upload>
                </div>
                <tablePagination :total="0">
                    <el-table v-loading="loading" :data="dataList" pageSize="1000" border size="mini">
                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                        <el-table-column label="文档名称" prop="name"></el-table-column>
                        <el-table-column label="更新(创建)时间" width="150">
                            <template slot-scope="scope">
                                {{new Date((scope.row.update_time||scope.row.created_at)*1000).Format("yyyy-MM-dd hh:mm:ss")}}
                            </template>
                        </el-table-column>
                        <el-table-column label="分段数" prop="slice_count"></el-table-column>
                        <el-table-column label="大小(字节)">
                            <template slot-scope="scope">
                                {{scope.row.size||scope.row.word_count}}
                            </template>
                        </el-table-column>
                        <el-table-column label="召回次数" prop="hit_count"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="180">
                            <template slot-scope="scope">
                                    <el-upload
                                        style="display: inline-block;margin-right: 10px"
                                        :action="''"
                                        :show-file-list="false"
                                        :httpRequest="(file)=>uploadFile(file,scope.row)">
                                        <el-button plain  size="mini" type="warning">重新上传</el-button>
                                    </el-upload>
                                    <el-button type="danger " size="mini" plain
                                               @click="deleteFile(scope.row)">删除
                                    </el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </tablePagination>

    </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    import tablePagination from '@c/tablePagination'
    export default {
        data() {
            return {
                formParam: {
                    datasetId: this.$route.params.id||'',
                    platformType: this.$route.query.platformType||'coze',
                },
                dataList: [],
                total: 0,
                loading: false,
                currentKnowledge:{
                    documents: {
                        total:0,
                        data:[]
                    },
                    id:''
                }
            }
        },
        components: {
            defaultSec, tablePagination
        },
        mounted(){
            if(this.formParam.datasetId) {
                this.initList()
            }
        },
        methods: {
            initList() {
                this.loading = true
                this.dataList=[]
                this.$apiGet('lechun-ai/knowledge/getDocumentList', {  ...this.formParam}).then(res => {
                    this.loading = false
                    this.dataList = res.data||res||[]
                    this.total = res.total||res.length||0
                })
            },
            deleteFile(row){
                this.$confirm('删除后不可撤销，确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$apiGet('lechun-ai/knowledge/delete', {
                        documentId:row.document_id||row.id||'',
                        datasetId: this.formParam.datasetId||'',
                        platformType:this.formParam.platformType
                    }).then(res => {
                        console.log(res)
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.initList()
                    })
                }).catch(() => {

                });
            },
            uploadFile(file,row) {
                console.log(234,file,this.currentKnowledge,row)
                let fileForm = new FormData();
                fileForm.append('file',file.file)
                fileForm.append('datasetId',this.formParam.datasetId||'')
                fileForm.append('documentId',row.document_id||row.id||'')
                fileForm.append('platformType',this.formParam.platformType)
                this.$apiUpload('lechun-ai/knowledge/save',fileForm).then(res => {
                    console.log(1212,res)
                    if(res.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.initList()
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }



                })
            },
        }
    }
</script>


<style scoped>
    .expand-title {
        width: 70px;
        color: #444548;
        line-height: 30px;
        text-align: right;
        margin-right: 10px;
        font-weight: 600;
    }

    .expand-flex {
        justify-content: flex-start;
        align-items: center;
        align-content: center;
    }
</style>